import * as Sentry from '@sentry/react';

// Configure sentry for production
if (import.meta.env.VITE_APP_ENV == 'production') {
  Sentry.init({
    dsn: 'https://3b5cdbf8d65f4fbba9bc20068ff76456@o36100.ingest.sentry.io/5613800',
    // dsn: 'https://f74ee2cbb0054bc99734eae81f140b0a@o36100.ingest.sentry.io/5616095',
    integrations: [Sentry.browserTracingIntegration()],
    environment: import.meta.env.VITE_APP_ENV || 'development',
    release: 'relcore-site@' + import.meta.env.VITE_APP_VERSION,
    normalizeDepth: 5,
    beforeSend(event) {
      event.breadcrumbs = (event.breadcrumbs || []).filter(
        (b) =>
          // Filter out redux logging messages
          b.data == null ||
          typeof b.data.arguments != 'object' ||
          b.data.arguments.length < 3 ||
          b.data.arguments[1].indexOf('color: #') !== 0,
      );
      return event;
    },
  });
}

export default Sentry;
